var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HighlightedMarkets, TrendMarkets } from './highlightedmarkets';
import { calcMinutesLest, getDateHumanize, ServerDate, timeFormat, useForceUpdate, } from '../../../lib/misc.functions';
import { LiveScoreStatusType } from '../../../definitions/constants/event-status-type.constant';
import Play from '../../../assets/feather/play.svg';
import { eventEndedStatuses } from '../../../definitions/constants/event-result-type';
import { eventMapping, eventUpdateSubject, marketMapping } from '../../../store/sportsbook.store';
import { betSlipActionSubject } from '../../../store/betslip.store';
import { isAndroid, isIOS, isMacOs, isWindows, osVersion } from 'react-device-detect';
import BellOn from '../../../assets/feather/bell.svg';
import { customStyles } from '../../../definitions/constants/modal.constant';
import Modal from 'react-modal';
import { useForm } from 'react-hook-form';
import { Storage } from '../../../lib/localstorege.service';
import { ApiService } from '../../../lib/http.service';
import { env } from '../../../definitions/global.vars';
import { modalServiceSubject } from '../../../components/modal/modal';
import rapidIcon from '../../../assets/img/rapid.svg';
import { rapidMarkets } from '../../../definitions/constants/market-categories.constant';
import iconDown from '../../../assets/feather/chevron-down.svg';
import iconDuelle from '../../../assets/new-sport-icons/duello.png';
import iconCustomRatio from '../../../assets/img/fire.gif';
import { CompetitionLabelHelper } from '../../../definitions/constants/competition-maps';
import { addToBetSlip } from '../../../services/betslip.services';
import Lock from '../../../assets/feather/lock.svg';
var removerTimer = {};
var updateTimer = {};
export function Event(props) {
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    // fixme: re-render edilmesede bu kısım sürekli çalıştırılıyor gibi kontrol et
    // console.log(props.event.eventId)
    // const highlightedMarkets = props.highlightedMarkets;
    var eventType = props.eventType;
    var event = props.event;
    var params = props.params;
    var parentEvent = props.parentEvent;
    var setShowEventDetail = props.context;
    var fromOutSource = props.fromOutSource;
    var isDuelloCombination = props.isDuelloCombination;
    var openAsNewPage = false;
    if ((isAndroid && Number(osVersion.split('.')[0]) >= 9) || isMacOs || isWindows ||
        (isIOS && Number(osVersion.split('.')[0]) >= 15)) {
        openAsNewPage = true;
    }
    var width = window.innerWidth;
    if (event.liveScoreStatus && event.matchPlayTime !== undefined && event.matchPlayTime !== null && event.matchPlayTime !== '' && event.matchPlayTime !== ' ' && Number(event.matchPlayTime) >= 0) {
        var time_statuses = ['520', '521', '522', '523', '700'];
        if (time_statuses.includes(event.liveScoreStatus.toString())) {
            event.minute = event.matchPlayTime + '.dk';
        }
        else {
            event.minute = LiveScoreStatusType[Number(event.liveScoreStatus)];
        }
    }
    var durationInMinutes = event.sportSlug === 'futbol' ? 85 : 35;
    var diffMin = ServerDate().getTime() - new Date(event.eventDate).getTime();
    var exStatus = event.isRemoved;
    if (event && ((Number(event.isLiveEvent) === 1 && eventEndedStatuses.indexOf(event.liveScoreStatus) !== -1 && diffMin > (durationInMinutes * 60000)) ||
        (Number(event.isLiveEvent) === 0 && new Date(event.eventDate) < ServerDate()))) {
        event.isRemoved = true;
        if (exStatus !== event.isRemoved) {
            forceUpdate();
        }
    }
    else {
        event.isRemoved = false;
    }
    var getEsoccerEventTime = function () {
        if (event.matchStatus == '1p') {
            return '1.Y';
        }
        else if (event.matchStatus == '2p') {
            return '2.Y';
        }
        else if (event.matchStatus == 'ended') {
            return 'MS';
        }
        else {
            return '';
        }
    };
    // useEffect(() => {
    //     const loginSubject_subscription: Subscription = loginSubject.subscribe((res:any) => {
    //         if (member && res === 'addition_ratio') {
    //             forceUpdate()
    //         }
    //     });
    //     return () => {
    //         loginSubject_subscription.unsubscribe();
    //     }
    // }, []);
    // useEffect(() => {
    //     if (event.isRemoved === true || eventEndedStatuses.includes(Number(event.liveScoreStatus))) {
    //         setTimeout(() => {
    //             const ev: any = document.getElementById('eventId_' + event.eventId)
    //             if (ev) {
    //                 try {
    //                     const eventLabel = event.competitionGroupName + ' ' + event.competitionName.replace(event.competitionGroupName, '',) + '__' + getDateHumanize(event.eventDate) + ' ' + event.eventDate.split('T')[1].substring(0, 5) + '__' + event.sportSlug;
    //                     const headerElement: any = document.getElementById(eventLabel);
    //                     const evHasHeader = ev.firstChild.className.includes('groupHeader')
    //                     let evHasChild = ev.nextElementSibling.firstChild.className.includes('groupHeader')
    //                     if (evHasHeader && !evHasChild) {
    //                         ev.children[1].style.display = 'none';
    //                     } else {
    //                         ev.style.display = 'none';
    //                     }
    //                     if (!headerElement.parentElement.nextElementSibling.firstChild.className.includes("groupHeader") && headerElement.parentElement.nextElementSibling.style.display == 'none') {
    //                         ev.style.display = 'none'
    //                     }
    //                 } catch (e) {
    //                     console.error(e)
    //                 }
    //             }
    //         }, 2000)
    //     }
    // })
    useEffect(function () {
        var betSlipActionSubject_subscription = betSlipActionSubject.subscribe(function (events) {
            if (typeof events === 'object' && event) {
                if (['toggle', 'remove'].includes(events.action)) {
                    if (events.betSlip.sportEvent) {
                        if (events.betSlip.sportEvent.eventId === event.eventId) {
                            forceUpdate();
                        }
                    }
                }
                else if (events.action === 'clear') {
                    if (events.betSlip.includes(event.eventId)) {
                        forceUpdate();
                    }
                }
            }
        });
        var eventUpdateSubject_subscription = eventUpdateSubject.subscribe(function (events) {
            if (events.includes('duello')) {
                if (events.includes(String(event.eventId)) || events.includes(Number(event.eventId))) {
                    forceUpdate();
                }
            }
            else {
                if (events.includes(String(event.eventId)) || events.includes(Number(event.eventId))) {
                    if (updateTimer[String(event.eventId)]) {
                        clearTimeout(updateTimer[String(event.eventId)]);
                    }
                    updateTimer[String(event.eventId)] = setTimeout(function () {
                        forceUpdate();
                    }, 300);
                }
            }
        });
        return function () {
            if (removerTimer[String(event.eventId)]) {
                clearTimeout(removerTimer[String(event.eventId)]);
            }
            if (updateTimer[String(event.eventId)]) {
                clearTimeout(updateTimer[String(event.eventId)]);
            }
            betSlipActionSubject_subscription.unsubscribe();
            eventUpdateSubject_subscription.unsubscribe();
        };
    }, []);
    // console.log(isDuelloCombination,  parentEvent)
    if (isDuelloCombination && parentEvent.showSubs !== true) {
        return _jsx(React.Fragment, {}, void 0);
    }
    var bettingPhase = Number(event.bettingPhase);
    if (event.isRemoved === true || eventEndedStatuses.includes(Number(event.liveScoreStatus))) {
        removerTimer[String(event.eventId)] = setTimeout(function () {
            var ev = document.getElementById('eventId_' + event.eventId);
            if (ev) {
                try {
                    var eventLabel = event.competitionGroupName + ' ' + event.competitionName.replace(event.competitionGroupName, '') + '__' + getDateHumanize(event.eventDate) + ' ' + event.eventDate.split('T')[1].substring(0, 5) + '__' + event.sportSlug;
                    var headerElement = document.getElementById(eventLabel);
                    var evHasHeader = ev.firstChild.className.includes('groupHeader');
                    var evHasChild = ev.nextElementSibling.firstChild.className.includes('groupHeader');
                    if (evHasHeader && !evHasChild) {
                        ev.children[1].style.display = 'none';
                    }
                    else {
                        ev.style.display = 'none';
                    }
                    if (!headerElement.parentElement.nextElementSibling.firstChild.className.includes("groupHeader") && headerElement.parentElement.nextElementSibling.style.display == 'none') {
                        ev.style.display = 'none';
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
            // const ev = document.getElementById('eventId_' + event.eventId);
            // if(ev) {
            //
            //     try{
            //         const list:any = ev.getElementsByClassName('event-card')
            //         const isGroupHeaderExist = ev.getElementsByClassName('groupHeader');
            //         // console.log("list", list)
            //         if(list && list.length > 0 && list[0]){
            //             if (isGroupHeaderExist.length > 0){
            //                 list[0].style.display = 'none';
            //             }else{
            //                 ev.style.display = 'none';
            //             }
            //         }
            //
            //         const nextEvent:any = ev.nextSibling
            //         if (nextEvent != null) {
            //             const haveGroupTitle = nextEvent.getElementsByClassName('groupHeader')
            //             if (haveGroupTitle.length > 0) {
            //                 ev.style.display = 'none';
            //             }
            //         }
            //     } catch (e) {
            //         console.log("errorrr in remove");
            //         console.log(e);
            //     }
            // }
        }, 100);
    }
    var toggleEventCombinations = function (event) {
        event.showSubs = event.showSubs !== true ? true : false;
        var trigEvent = [event.eventId];
        try {
            var event1 = eventMapping[String(event.eventClosedCombination[0].eventId)];
            if (event1) {
                trigEvent.push(String(event1.eventId));
            }
        }
        catch (e) {
            console.error(e);
        }
        try {
            var event2 = eventMapping[String(event.eventClosedCombination[1].eventId)];
            if (event2) {
                trigEvent.push(String(event2.eventId));
            }
        }
        catch (e) {
            console.error(e);
        }
        // if(event1.toggleCombination!==true){
        //     event1.toggleCombination = true;
        // }else{
        //     event1.toggleCombination = false;
        // }
        //
        // if(event2.toggleCombination!==true){
        //     event2.toggleCombination = true;
        // }else{
        //     event2.toggleCombination = false;
        // }
        // console.log(trigEvent)
        // forceUpdate();
        trigEvent.push('duello');
        eventUpdateSubject.next(trigEvent);
    };
    var haveRapidMarket = marketMapping[String(event.eventId)].filter(function (el) { return rapidMarkets.includes(el.marketType + '-' + el.marketSubType) && (el.marketStatus === 1 || el.marketStatus < 0); });
    if (event.isRemoved === true ||
        eventEndedStatuses.includes(Number(event.liveScoreStatus))) {
        return _jsx(React.Fragment, {}, void 0);
    }
    return (_jsxs(React.Fragment, { children: [_jsx("div", { className: "corner" }, void 0), width > 986 || bettingPhase === 1 ? (_jsxs("div", __assign({ className: 'event-date' + (bettingPhase === 1 ? ' double-line' : '') }, { children: [_jsx("div", __assign({ className: "mbs mbs-".concat(event.minCombiCount) }, { children: event.minCombiCount }), void 0), haveRapidMarket.length > 0 ? (_jsxs("div", __assign({ className: 'mbs' }, { children: [_jsx("img", { src: rapidIcon, className: 'rapidIcon' }, void 0), " H\u0131zl\u0131"] }), void 0)) : (_jsx(React.Fragment, {}, void 0)), event.hasCustomratio || event.additionalBonus ? (_jsxs("div", __assign({ className: 'customRatio' }, { children: [_jsx("img", { src: iconCustomRatio, className: 'rapidIcon' }, void 0), " Y\u00FCksek Oran"] }), void 0)) : (_jsx(React.Fragment, {}, void 0)), event.liveStreamAvailable > 0 ? (_jsx("div", __assign({ className: 'liveStreamBadge ' +
                            (event.liveStreamAvailable === 2 ? 'blink' : '') }, { children: _jsx("img", { src: Play }, void 0) }), void 0)) : (''), (Number(event.isLiveEvent) === 1 &&
                        bettingPhase === 0 &&
                        !event.minute) ||
                        (Number(event.isLiveEvent) === 1 &&
                            bettingPhase === 1 &&
                            !event.minute) ? (_jsx("div", __assign({ className: "is-live" }, { children: "Canl\u0131" }), void 0)) : null, bettingPhase === 1 && event.minute ? (_jsx("span", __assign({ className: "minute mr-1" }, { children: event.sportId.toString() == '137'
                            ? getEsoccerEventTime()
                            : event.minute }), void 0)) : null, width > 986 && bettingPhase === 0 && event.eventDate ? (_jsx("div", __assign({ className: 'time float-left' }, { children: timeFormat(event.eventDate) }), void 0)) : null] }), void 0)) : null, _jsx("a", __assign({ style: { display: 'block' }, className: 'participants-labels' +
                    (bettingPhase === 1 && event.currentScore ? ' double-line' : ''), 
                // to = {(fromOutSource || openAsNewPage)
                //     ?'/iddaa/' + event.sportSlug + '/' + eventType + '/' + event.competitionId + '/' + event.eventId
                //     :setShowEventDetail(event)
                // }
                onClick: function () {
                    if (fromOutSource || openAsNewPage) {
                        if ((params === null || params === void 0 ? void 0 : params.sportSlug) == 'canli') {
                            navigate('/iddaa/canli/' +
                                (eventType !== null && eventType !== void 0 ? eventType : 'tumu') +
                                '/' +
                                event.competitionId +
                                '/' +
                                event.eventId);
                        }
                        else {
                            navigate('/iddaa/' +
                                event.sportSlug +
                                '/' +
                                eventType +
                                '/' +
                                event.competitionId +
                                '/' +
                                event.eventId);
                        }
                    }
                    else {
                        setShowEventDetail(event);
                    }
                } }, { children: _jsxs("div", __assign({ className: 'participants' + (bettingPhase === 1 ? ' double-line' : '') }, { children: [bettingPhase === 1 ? (_jsxs(React.Fragment, { children: [_jsxs("div", __assign({ className: "labels" }, { children: [_jsxs("span", { children: [event.eventParticipant[0].participantName, Array.from(Array(Number(event.homeRedCards)).keys()).map(function (x, y) {
                                                    return _jsx("i", { className: "red-card" }, x + y);
                                                })] }, void 0), _jsxs("span", { children: [event.eventParticipant[1].participantName, Array.from(Array(Number(event.awayRedCards)).keys()).map(function (x, y) {
                                                    return _jsx("i", { className: "red-card" }, x + y);
                                                })] }, void 0)] }), void 0), event.currentScore ? (_jsxs(React.Fragment, { children: [event.sportSlug === 'futbol' ? (_jsxs(React.Fragment, { children: [event.scores &&
                                                    event.scores.homeTeam &&
                                                    ['2H', 'FT', '1ET', '2ET'].includes(event.scores.status) ? (_jsxs("div", __assign({ className: "scores prev-period" }, { children: [_jsx("span", __assign({ className: "label" }, { children: "\u0130.Y." }), void 0), _jsx("span", { children: event.scores.homeTeam.firstHalf }, void 0), _jsx("span", { children: event.scores.awayTeam.firstHalf }, void 0)] }), void 0)) : null, event.scores &&
                                                    event.scores.homeTeam &&
                                                    ['1ET', '2ET', '3ET', '4ET'].includes(event.scores.status) ? (_jsxs("div", __assign({ className: "scores prev-period" }, { children: [_jsx("span", __assign({ className: "label" }, { children: "M.S." }), void 0), _jsx("span", { children: event.scores.homeTeam.secondHalf }, void 0), _jsx("span", { children: event.scores.awayTeam.secondHalf }, void 0)] }), void 0)) : null] }, void 0)) : null, event.sportSlug === 'basketbol' ||
                                            event.sportSlug === 'voleybol' ? (_jsxs(React.Fragment, { children: [event.scores &&
                                                    event.scores.homeTeam &&
                                                    event.scores.homeTeam.periods &&
                                                    [
                                                        '1H',
                                                        'Q2',
                                                        '2H',
                                                        'Q3',
                                                        'HT',
                                                        'Q4',
                                                        'FT',
                                                        'Q5',
                                                        '1ET',
                                                        '1S',
                                                        '2S',
                                                        '3S',
                                                        '4S',
                                                        '5S',
                                                    ].includes(event.scores.status) ? (_jsx("div", __assign({ className: "scores prev-period" }, { children: event.sportSlug === 'basketbol' ? (_jsxs(React.Fragment, { children: [_jsx("span", __assign({ className: "label" }, { children: "1.\u00C7" }), void 0), _jsx("span", { children: event.scores.homeTeam.periods.first }, void 0), _jsx("span", { children: event.scores.awayTeam.periods.first }, void 0)] }, void 0)) : (_jsxs(React.Fragment, { children: [_jsx("span", __assign({ className: "label" }, { children: "1.S" }), void 0), _jsx("span", { children: event.scores.homeTeam.sets.first }, void 0), _jsx("span", { children: event.scores.awayTeam.sets.first }, void 0)] }, void 0)) }), void 0)) : null, event.scores &&
                                                    event.scores.homeTeam &&
                                                    event.scores.homeTeam.periods &&
                                                    [
                                                        '2H',
                                                        'Q2',
                                                        '1H',
                                                        'Q3',
                                                        'HT',
                                                        'Q4',
                                                        'Q5',
                                                        'FT',
                                                        '2S',
                                                        '1ET',
                                                        '3S',
                                                        '4S',
                                                        '5S',
                                                    ].includes(event.scores.status) ? (_jsx("div", __assign({ className: "scores prev-period " }, { children: event.sportSlug === 'basketbol' ? (_jsxs(React.Fragment, { children: [_jsx("span", __assign({ className: "label" }, { children: "2.\u00C7" }), void 0), _jsx("span", { children: event.scores.homeTeam.periods.second }, void 0), _jsx("span", { children: event.scores.awayTeam.periods.second }, void 0)] }, void 0)) : (_jsxs(React.Fragment, { children: [_jsx("span", __assign({ className: "label" }, { children: "2.S" }), void 0), _jsx("span", { children: event.scores.homeTeam.sets.second }, void 0), _jsx("span", { children: event.scores.awayTeam.sets.second }, void 0)] }, void 0)) }), void 0)) : null, event.scores &&
                                                    event.scores.homeTeam &&
                                                    event.scores.homeTeam.periods &&
                                                    [
                                                        '2H',
                                                        'HT',
                                                        'Q4',
                                                        'Q3',
                                                        'Q5',
                                                        'FT',
                                                        '1ET',
                                                        '3S',
                                                        '4S',
                                                        '5S',
                                                    ].includes(event.scores.status) ? (_jsx("div", __assign({ className: "scores prev-period" }, { children: event.sportSlug === 'basketbol' ? (_jsxs(React.Fragment, { children: [_jsx("span", __assign({ className: "label" }, { children: "3.\u00C7" }), void 0), _jsx("span", { children: event.scores.homeTeam.periods.third }, void 0), _jsx("span", { children: event.scores.awayTeam.periods.third }, void 0)] }, void 0)) : (_jsxs(React.Fragment, { children: [_jsx("span", __assign({ className: "label" }, { children: "3.S" }), void 0), _jsx("span", { children: event.scores.homeTeam.sets.third }, void 0), _jsx("span", { children: event.scores.awayTeam.sets.third }, void 0)] }, void 0)) }), void 0)) : null, event.scores &&
                                                    event.scores.homeTeam &&
                                                    event.scores.homeTeam.periods &&
                                                    ['FT', '1ET', '4S', 'Q5', '5S', 'Q4'].includes(event.scores.status) ? (_jsx("div", __assign({ className: "scores prev-period" }, { children: event.sportSlug === 'basketbol' ? (_jsxs(React.Fragment, { children: [_jsx("span", __assign({ className: "label" }, { children: "4.\u00C7" }), void 0), _jsx("span", { children: event.currentScore.split(':')[0] -
                                                                    (event.scores.homeTeam.periods.first +
                                                                        event.scores.homeTeam.periods.second +
                                                                        event.scores.homeTeam.periods.third) }, void 0), _jsx("span", { children: event.currentScore.split(':')[1] -
                                                                    (event.scores.awayTeam.periods.first +
                                                                        event.scores.awayTeam.periods.second +
                                                                        event.scores.awayTeam.periods.third) }, void 0)] }, void 0)) : (_jsxs(React.Fragment, { children: [_jsx("span", __assign({ className: "label" }, { children: "4.S" }), void 0), _jsx("span", { children: event.scores.homeTeam.sets.fourth }, void 0), _jsx("span", { children: event.scores.awayTeam.sets.fourth }, void 0)] }, void 0)) }), void 0)) : null, event.scores &&
                                                    event.scores.homeTeam &&
                                                    event.scores.homeTeam.periods &&
                                                    ['Q5', '5S', '1ET', '2ET', '3ET', '4ET'].includes(event.scores.status) ? (_jsx("div", __assign({ className: "scores prev-period" }, { children: event.sportSlug === 'basketbol' ? (_jsxs(React.Fragment, { children: [_jsx("span", __assign({ className: "label" }, { children: "UZ" }), void 0), _jsx("span", { children: event.scores.homeTeam.periods.fifth }, void 0), _jsx("span", { children: event.scores.awayTeam.periods.fifth }, void 0)] }, void 0)) : (_jsxs(React.Fragment, { children: [_jsx("span", __assign({ className: "label" }, { children: "5.S" }), void 0), _jsx("span", { children: event.scores.homeTeam.sets.fifth }, void 0), _jsx("span", { children: event.scores.awayTeam.sets.fifth }, void 0)] }, void 0)) }), void 0)) : null] }, void 0)) : null, event.scores &&
                                            event.scores.homeTeam &&
                                            ['1ET', '2ET', '3ET', '4ET'].includes(event.scores.status) ? (_jsxs("div", __assign({ className: "scores", style: { marginTop: '-18px' } }, { children: [_jsx("span", __assign({ className: "label" }, { children: "UZ" }), void 0), _jsx("span", { children: event.scores.homeTeam.current }, void 0), _jsx("span", { children: event.scores.awayTeam.current }, void 0)] }), void 0)) : (_jsxs("div", __assign({ className: "scores" }, { children: [_jsx("span", { children: event.currentScore.split(':')[0] }, void 0), _jsx("span", { children: event.currentScore.split(':')[1] }, void 0)] }), void 0))] }, void 0)) : null] }, void 0)) : (_jsxs(React.Fragment, { children: [width < 968 ? (_jsxs(React.Fragment, { children: [_jsx("div", __assign({ className: "mbs mbs-".concat(event.minCombiCount) }, { children: event.minCombiCount }), void 0), haveRapidMarket.length > 0 ? (_jsxs("div", __assign({ className: 'mbs', style: { minWidth: 50 } }, { children: [_jsx("img", { src: rapidIcon, className: 'rapidIcon' }, void 0), " H\u0131zl\u0131"] }), void 0)) : (_jsx(React.Fragment, {}, void 0)), event.liveStreamAvailable > 0 ? (_jsx("div", __assign({ className: 'liveStreamBadge ' +
                                                (event.liveStreamAvailable === 2 ? 'blink' : '') }, { children: _jsx("img", { src: Play }, void 0) }), void 0)) : (''), event.hasCustomratio || event.additionalBonus ? (_jsxs("div", __assign({ className: 'customRatio' }, { children: [_jsx("img", { src: iconCustomRatio, className: 'rapidIcon' }, void 0), " Y.O."] }), void 0)) : (_jsx(React.Fragment, {}, void 0)), Number(event.isLiveEvent) === 1 &&
                                            bettingPhase === 0 &&
                                            !event.minute ? (_jsx("div", __assign({ className: "is-live" }, { children: "Canl\u0131" }), void 0)) : null] }, void 0)) : (_jsx(React.Fragment, {}, void 0)), _jsx("div", __assign({ className: "labels single-line" }, { children: event.eventName }), void 0)] }, void 0)), width > 968 && bettingPhase === 0 ? (_jsxs("div", __assign({ className: "labels" }, { children: [_jsx("span", { children: event.eventParticipant[0].participantName }, void 0), _jsx("span", { children: event.eventParticipant[1].participantName }, void 0)] }), void 0)) : null] }), void 0) }), void 0), (params === null || params === void 0 ? void 0 : params.eventType) === 'trend' ? (_jsx("div", __assign({ className: 'highlighted-odds trend-events' }, { children: _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(TrendMarkets, { event: event, trendMarkets: event.trendMarkets }, void 0), _jsx("div", __assign({ className: "more-odds mt-0" }, { children: _jsx("button", __assign({ className: "btn added-".concat(event.isAdded), onClick: function () {
                                    if (isDuelloCombination) {
                                        navigate('/iddaa/duello/tumu/' +
                                            event.competitionId +
                                            '/' +
                                            event.eventId);
                                    }
                                    else {
                                        if (fromOutSource || openAsNewPage) {
                                            if ((params === null || params === void 0 ? void 0 : params.sportSlug) == 'canli') {
                                                navigate('/iddaa/canli/' +
                                                    (eventType !== null && eventType !== void 0 ? eventType : 'tumu') +
                                                    '/' +
                                                    event.competitionId +
                                                    '/' +
                                                    event.eventId);
                                            }
                                            else {
                                                navigate('/iddaa/' +
                                                    event.sportSlug +
                                                    '/' +
                                                    eventType +
                                                    '/' +
                                                    event.competitionId +
                                                    '/' +
                                                    event.eventId);
                                            }
                                        }
                                        else {
                                            setShowEventDetail(event);
                                        }
                                    }
                                } }, { children: _jsxs("div", __assign({ className: "outcome-name" }, { children: ["+", event.marketOutcomeCount] }), void 0) }), void 0) }), void 0)] }), void 0) }), void 0)) : (_jsx("div", __assign({ className: "highlighted-odds" }, { children: _jsxs("div", __assign({ style: { display: 'flex' } }, { children: [event.sportSlug === 'duello' && event.eventClosedCombination ? (_jsx("div", __assign({ className: ' subscribe', onClick: function () {
                                toggleEventCombinations(event);
                            } }, { children: _jsx("img", { className: "reinvert-color", src: iconDuelle, width: 13 }, void 0) }), void 0)) : (_jsx(ScoreAlarmSubscription, { event: event }, void 0)), _jsx(HighlightedMarkets, { style: "border:1px solid #000;", event: event, highlightedMarkets: event.highlightedMarkets }, void 0), _jsx("div", __assign({ className: "more-odds" }, { children: _jsx("button", __assign({ className: "btn added-".concat(event.isAdded), onClick: function () {
                                    if (isDuelloCombination) {
                                        navigate('/iddaa/duello/tumu/' +
                                            event.competitionId +
                                            '/' +
                                            event.eventId);
                                    }
                                    else {
                                        if (fromOutSource || openAsNewPage) {
                                            if ((params === null || params === void 0 ? void 0 : params.sportSlug) == 'canli') {
                                                navigate('/iddaa/canli/' +
                                                    (eventType !== null && eventType !== void 0 ? eventType : 'tumu') +
                                                    '/' +
                                                    event.competitionId +
                                                    '/' +
                                                    event.eventId);
                                            }
                                            else {
                                                navigate('/iddaa/' +
                                                    event.sportSlug +
                                                    '/' +
                                                    eventType +
                                                    '/' +
                                                    event.competitionId +
                                                    '/' +
                                                    event.eventId);
                                            }
                                        }
                                        else {
                                            setShowEventDetail(event);
                                        }
                                    }
                                } }, { children: _jsxs("div", __assign({ className: "outcome-name" }, { children: ["+", event.marketOutcomeCount] }), void 0) }), void 0) }), void 0), event.sportSlug === 'duello' && event.eventClosedCombination ? (_jsx("div", __assign({ className: "more-odds" }, { children: _jsx("button", __assign({ className: "btn added-".concat(event.showSubs), onClick: function () {
                                    toggleEventCombinations(event);
                                } }, { children: _jsx("div", __assign({ className: "outcome-name" }, { children: _jsx("img", { className: 'invert-color', style: { height: 16 }, src: iconDown }, void 0) }), void 0) }), void 0) }), void 0)) : (_jsx(React.Fragment, {}, void 0))] }), void 0) }), void 0)), _jsx("div", { className: "clearfix" }, void 0), event.sportSlug === 'duello' &&
                event.eventClosedCombination &&
                event.showSubs ? (_jsx("div", { className: 'isDuelloCombination' }, void 0)) : (_jsx(React.Fragment, {}, void 0))] }, void 0));
}
export function ScoreAlarmSubscription(props) {
    var _a = useState(false), modalVisible = _a[0], setModalVisible = _a[1];
    var apiService = new ApiService();
    var event = props.event;
    var setScoreAlarm = function (event) {
        setModalVisible(event);
    };
    var closeModal = function () {
        setModalVisible(false);
    };
    var _b = useForm(), register = _b.register, handleSubmit = _b.handleSubmit, reset = _b.reset;
    var onSubmit = function (data) {
        var obje = {
            matchBegin: data.matchBegin ? true : false,
            matchBeforeBegin: data.matchBeforeBegin ? true : false,
            goals: data.goals ? true : false,
            redCards: data.redCards ? true : false,
            periods: data.periods ? true : false,
            matchEnded: data.matchEnded ? true : false,
            event_id: event.eventId,
            token: Storage.get('token'),
            action: event.alarmStatus ? 'remove' : 'add',
        };
        apiService.start('post', env.scores + '/api/subscribe-event/', obje, true).then(function (result) {
            if (result.status === 'added') {
                closeModal();
                modalServiceSubject.next({
                    title: 'Alarm kuruldu!',
                    timeout: 3000,
                    content: 'Karşılaşmaya ait bildirim alarmu kuruldu, eğer bildirim almayı durdurmak isterseniz, kurulum ekranından "İptal Et" butonuna basarak iptal edebilirsiniz.',
                });
                event.alarmStatus = true;
            }
            else if (result.status === 'removed') {
                event.alarmStatus = false;
                closeModal();
            }
            else {
                modalServiceSubject.next({
                    title: 'Bir hata oluştu',
                    timeout: 3000,
                    content: result.message,
                });
            }
            eventUpdateSubject.next([event.eventId]);
        });
    };
    return (_jsxs(React.Fragment, { children: [_jsx("div", __assign({ className: ' subscribe ' + (event.alarmStatus ? 'active' : ''), style: { background: event.alarmStatus ? 'var(--color-oley)' : '' }, onClick: function () {
                    setScoreAlarm(event);
                } }, { children: _jsx("img", { title: "Ma\u00E7 Takip", src: BellOn, width: 13, className: 'invert-color', style: { filter: event.alarmStatus ? 'invert(1)' : '' } }, void 0) }), void 0), _jsxs(Modal, __assign({ isOpen: modalVisible !== false ? true : false, onRequestClose: closeModal, style: customStyles, contentLabel: "" }, { children: [_jsx("div", __assign({ className: "modal-header" }, { children: _jsx("h3", { children: "Kar\u015F\u0131la\u015Fma Bildirimi" }, void 0) }), void 0), _jsx("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: _jsxs("div", __assign({ className: "modal-body", style: { height: 'auto' } }, { children: [!event.alarmStatus ? (_jsx(React.Fragment, { children: _jsxs("ul", __assign({ className: "competitionFilterList", style: { height: 'auto' } }, { children: [Number(event.bettingPhase) === 0 &&
                                                Number(calcMinutesLest(event.eventDate)) > 10 ? (_jsxs("li", { children: [_jsx("div", __assign({ className: "float-left" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ defaultChecked: true, disabled: event.alarmStatus }, register('matchBeforeBegin'), { type: "checkbox", 
                                                                    // checked={sportsbookFilter.filterCompetition.indexOf(el[1][0].competitionId) !== -1}
                                                                    onChange: function () {
                                                                        // setFilterCompetitions(el[1][0].compeWtitionId);
                                                                        // forceUpdate();
                                                                    } }), void 0), "Ma\u00E7 Hat\u0131rlatma"] }, void 0) }), void 0), _jsx("div", { className: "clearfix" }, void 0)] }, void 0)) : null, Number(event.bettingPhase) === 0 &&
                                                Number(calcMinutesLest(event.eventDate)) > 1 ? (_jsxs("li", { children: [_jsx("div", __assign({ className: "float-left" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ type: "checkbox", disabled: event.alarmStatus, defaultChecked: true }, register('matchBegin'), { 
                                                                    // checked={sportsbookFilter.filterCompetition.indexOf(el[1][0].competitionId) !== -1}
                                                                    onChange: function () {
                                                                        // setFilterCompetitions(el[1][0].competitionId);
                                                                        // forceUpdate();
                                                                    } }), void 0), "Ma\u00E7 ba\u015Flad\u0131"] }, void 0) }), void 0), _jsx("div", { className: "clearfix" }, void 0)] }, void 0)) : null, ['futbol'].includes(event.sportSlug) ? (_jsxs("li", { children: [_jsx("div", __assign({ className: "float-left" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ type: "checkbox", disabled: event.alarmStatus, defaultChecked: true }, register('goals')), void 0), "Gol"] }, void 0) }), void 0), _jsx("div", { className: "clearfix" }, void 0)] }, void 0)) : (_jsx(React.Fragment, {}, void 0)), event.sportSlug === 'futbol' ? (_jsxs("li", { children: [_jsx("div", __assign({ className: "float-left" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ type: "checkbox", disabled: event.alarmStatus, defaultChecked: true }, register('redCards')), void 0), "K\u0131rm\u0131z\u0131 Kart"] }, void 0) }), void 0), _jsx("div", { className: "clearfix" }, void 0)] }, void 0)) : (_jsx(React.Fragment, {}, void 0)), (event.sportSlug == 'futbol' &&
                                                Number(event.bettingPhase) !== 0 &&
                                                Number(event.matchPlayTime) < 45) ||
                                                ['futbol', 'basketbol'].includes(event.sportSlug) ? (_jsxs("li", { children: [_jsx("div", __assign({ className: "float-left" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ type: "checkbox", disabled: event.alarmStatus, defaultChecked: true }, register('periods')), void 0), "\u0130lk yar\u0131 skoru / Peryod bilgisi"] }, void 0) }), void 0), _jsx("div", { className: "clearfix" }, void 0)] }, void 0)) : null, _jsxs("li", { children: [_jsx("div", __assign({ className: "float-left" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ type: "checkbox", disabled: event.alarmStatus, defaultChecked: true }, register('matchEnded')), void 0), "Ma\u00E7 bitti"] }, void 0) }), void 0), _jsx("div", { className: "clearfix" }, void 0)] }, void 0)] }), void 0) }, void 0)) : (_jsx(React.Fragment, {}, void 0)), _jsx("div", __assign({ className: "modal-footer" }, { children: _jsxs("div", __assign({ className: "row" }, { children: [!event.alarmStatus ? (_jsx("button", __assign({ type: "submit", className: "btn btn-primary" }, { children: "Ayarla" }), void 0)) : (_jsx("button", __assign({ type: "submit", className: "btn btn-warning" }, { children: "\u0130ptal Et" }), void 0)), _jsx("div", __assign({ className: "btn btn-default", onClick: function () {
                                                    closeModal();
                                                } }, { children: "Vazge\u00E7" }), void 0)] }), void 0) }), void 0)] }), void 0) }), void 0)] }), void 0)] }, void 0));
}
export function TrendEvent(props) {
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    // fixme: re-render edilmesede bu kısım sürekli çalıştırılıyor gibi kontrol et
    // console.log(props.event.eventId)
    // const highlightedMarkets = props.highlightedMarkets;
    var eventType = props.eventType;
    var event = props.event;
    var params = props.params;
    var parentEvent = props.parentEvent;
    var setShowEventDetail = props.context;
    var fromOutSource = props.fromOutSource;
    var isDuelloCombination = props.isDuelloCombination;
    var openAsNewPage = false;
    if ((isAndroid && Number(osVersion.split('.')[0]) >= 9) || isMacOs || isWindows ||
        (isIOS && Number(osVersion.split('.')[0]) >= 15)) {
        openAsNewPage = true;
    }
    var width = window.innerWidth;
    if (event.liveScoreStatus && event.matchPlayTime !== undefined && event.matchPlayTime !== null && event.matchPlayTime !== '' && event.matchPlayTime !== ' ' && Number(event.matchPlayTime) >= 0) {
        var time_statuses = ['520', '521', '522', '523', '700'];
        if (time_statuses.includes(event.liveScoreStatus.toString())) {
            event.minute = event.matchPlayTime + '.dk';
        }
        else {
            event.minute = LiveScoreStatusType[Number(event.liveScoreStatus)];
        }
    }
    var durationInMinutes = event.sportSlug === 'futbol' ? 85 : 35;
    var diffMin = ServerDate().getTime() - new Date(event.eventDate).getTime();
    var exStatus = event.isRemoved;
    if (event && ((Number(event.isLiveEvent) === 1 && eventEndedStatuses.indexOf(event.liveScoreStatus) !== -1 && diffMin > (durationInMinutes * 60000)) ||
        (Number(event.isLiveEvent) === 0 && new Date(event.eventDate) < ServerDate()))) {
        event.isRemoved = true;
        if (exStatus !== event.isRemoved) {
            forceUpdate();
        }
    }
    else {
        event.isRemoved = false;
    }
    // useEffect(() => {
    //     const loginSubject_subscription: Subscription = loginSubject.subscribe((res:any) => {
    //         if (member && res === 'addition_ratio') {
    //             forceUpdate()
    //         }
    //     });
    //     return () => {
    //         loginSubject_subscription.unsubscribe();
    //     }
    // }, []);
    useEffect(function () {
        var betSlipActionSubject_subscription = betSlipActionSubject.subscribe(function (events) {
            if (typeof events === 'object' && event) {
                if (['toggle', 'remove'].includes(events.action)) {
                    if (events.betSlip.sportEvent) {
                        if (events.betSlip.sportEvent.eventId === event.eventId) {
                            forceUpdate();
                        }
                    }
                }
                else if (events.action === 'clear') {
                    if (events.betSlip.includes(event.eventId)) {
                        forceUpdate();
                    }
                }
            }
        });
        var eventUpdateSubject_subscription = eventUpdateSubject.subscribe(function (events) {
            if (events.includes('duello')) {
                if (events.includes(String(event.eventId)) || events.includes(Number(event.eventId))) {
                    forceUpdate();
                }
            }
            else {
                if (events.includes(String(event.eventId)) || events.includes(Number(event.eventId))) {
                    if (updateTimer[String(event.eventId)]) {
                        clearTimeout(updateTimer[String(event.eventId)]);
                    }
                    updateTimer[String(event.eventId)] = setTimeout(function () {
                        forceUpdate();
                    }, 300);
                }
            }
        });
        return function () {
            if (removerTimer[String(event.eventId)]) {
                clearTimeout(removerTimer[String(event.eventId)]);
            }
            if (updateTimer[String(event.eventId)]) {
                clearTimeout(updateTimer[String(event.eventId)]);
            }
            betSlipActionSubject_subscription.unsubscribe();
            eventUpdateSubject_subscription.unsubscribe();
        };
    }, []);
    // console.log(isDuelloCombination,  parentEvent)
    if (isDuelloCombination && parentEvent.showSubs !== true) {
        return _jsx(React.Fragment, {}, void 0);
    }
    var bettingPhase = Number(event.bettingPhase);
    if (event.isRemoved === true || eventEndedStatuses.includes(Number(event.liveScoreStatus))) {
        // console.log("Kaldır")
        removerTimer[String(event.eventId)] = setTimeout(function () {
            // console.log("hadii")
            var ev = document.getElementById('eventId_' + event.eventId);
            // console.log(ev)
            if (ev) {
                try {
                    var list = ev.getElementsByClassName('event-card');
                    // console.log("list", list)
                    if (list && list.length > 0 && list[0]) {
                        // console.log("set Style")
                        list[0].style.display = 'none';
                    }
                    var nextEvent = ev.nextSibling;
                    var haveGroupTitle = nextEvent.getElementsByClassName('groupHeader');
                    if (haveGroupTitle.length > 0) {
                        ev.style.display = 'none';
                    }
                }
                catch (e) {
                    console.log('errorrr in remove');
                    console.log(e);
                }
            }
        }, 1000);
    }
    return (_jsxs(React.Fragment, { children: [_jsx("div", { className: "corner" }, void 0), _jsxs("div", __assign({ className: "d-flex justify-content-between align-items-center mb-1 trend-event-header px-2 py-1", onClick: function () {
                    if (fromOutSource || openAsNewPage) {
                        console.log(params === null || params === void 0 ? void 0 : params.sportSlug);
                        if ((params === null || params === void 0 ? void 0 : params.sportSlug) == 'canli') {
                            navigate('/iddaa/canli/' +
                                (eventType !== null && eventType !== void 0 ? eventType : 'tumu') +
                                '/' +
                                event.competitionId +
                                '/' +
                                event.eventId);
                        }
                        else {
                            navigate('/iddaa/' +
                                event.sportSlug +
                                '/' +
                                eventType +
                                '/' +
                                event.competitionId +
                                '/' +
                                event.eventId);
                        }
                    }
                    else {
                        setShowEventDetail(event);
                    }
                } }, { children: [_jsxs("div", __assign({ className: 'd-flex align-items-center' }, { children: [_jsx("div", { style: { width: '20px', height: '20px' }, className: "icon game-event-icon mr-1  ".concat(event.sportSlug) }, void 0), _jsx("div", __assign({ className: "nowrap" }, { children: CompetitionLabelHelper(event.competitionGroupName +
                                    ' ' +
                                    event.competitionName.replace(event.competitionGroupName, '')) }), void 0)] }), void 0), _jsx("div", __assign({ className: "float-right" }, { children: timeFormat(event.eventDate) }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'd-flex justify-content-between align-items-center px-2', onClick: function () {
                    if (fromOutSource || openAsNewPage) {
                        console.log(params === null || params === void 0 ? void 0 : params.sportSlug);
                        if ((params === null || params === void 0 ? void 0 : params.sportSlug) == 'canli') {
                            navigate('/iddaa/canli/' +
                                (eventType !== null && eventType !== void 0 ? eventType : 'tumu') +
                                '/' +
                                event.competitionId +
                                '/' +
                                event.eventId);
                        }
                        else {
                            navigate('/iddaa/' +
                                event.sportSlug +
                                '/' +
                                eventType +
                                '/' +
                                event.competitionId +
                                '/' +
                                event.eventId);
                        }
                    }
                    else {
                        setShowEventDetail(event);
                    }
                } }, { children: [_jsxs("div", __assign({ className: 'd-flex align-items-center' }, { children: [_jsx("div", __assign({ className: "mbs mbs-".concat(event.minCombiCount) }, { children: event.minCombiCount }), void 0), bettingPhase === 1 && event.minute ? (_jsx("span", __assign({ className: "minute mr-1" }, { children: event.minute }), void 0)) : null, _jsx("div", __assign({ className: "mr-1" }, { children: event.eventName }), void 0), bettingPhase === 1 && event.currentScore ? (_jsxs("span", __assign({ className: 'fw-bold' }, { children: ["(", event.currentScore, ")"] }), void 0)) : null, (Number(event.isLiveEvent) === 1 &&
                                bettingPhase === 0 &&
                                !event.minute) ||
                                (Number(event.isLiveEvent) === 1 &&
                                    bettingPhase === 1 &&
                                    !event.minute) ? (_jsx("div", __assign({ className: "is-live" }, { children: "Canl\u0131" }), void 0)) : null] }), void 0), _jsxs("div", { children: [_jsx("span", __assign({ className: 'trend-highlight' }, { children: event.salesStats.total_count }), void 0), "Kez Oynand\u0131"] }, void 0)] }), void 0), _jsx("div", __assign({ className: 'highlighted-odds trend-events' }, { children: _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsx("div", __assign({ className: 'group' }, { children: _jsx("div", __assign({ className: "labels w-100" }, { children: _jsx("span", { children: event.trendMarkets[0].marketName }, void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: "group" }, { children: _jsxs("button", __assign({ className: "btn btn-odds btn-trend ".concat(event.trendMarkets[0].marketOutcome[0].isUpdated, " added-").concat(event.trendMarkets[0].marketOutcome[0].isSelected, " ") +
                                    (event.trendMarkets[0].marketStatus < 0 ? 'locked' : ''), onClick: function () {
                                    addToBetSlip(event, event.trendMarkets[0], event.trendMarkets[0].marketOutcome[0]);
                                } }, { children: [_jsxs("div", __assign({ className: "outcome-name nowrap" }, { children: [event.trendMarkets[0].marketOutcome[0].outcomeName, event.trendMarkets[0].specialOddsValue
                                                ? event.trendMarkets[0].specialOddsValue
                                                : null] }), void 0), _jsx("div", __assign({ className: "ratio text-center" }, { children: event.trendMarkets[0].marketStatus < 0 ? (_jsx("img", { src: Lock }, void 0)) : (_jsx(React.Fragment, { children: Number(event.trendMarkets[0].marketOutcome[0].fixedOddsWeb) > 1 &&
                                                event.trendMarkets[0].marketStatus !== 0 &&
                                                event.trendMarkets[0].marketStatus < 2
                                                ? Number(event.trendMarkets[0].marketOutcome[0].fixedOdds).toFixed(2)
                                                : '-' }, void 0)) }), void 0), _jsx("div", __assign({ className: 'text-right trend-percent' }, { children: "%41" }), void 0)] }), void 0) }), void 0)] }), void 0) }), void 0), _jsx("div", { className: "clearfix" }, void 0), event.sportSlug === 'duello' &&
                event.eventClosedCombination &&
                event.showSubs ? (_jsx("div", { className: 'isDuelloCombination' }, void 0)) : (_jsx(React.Fragment, {}, void 0))] }, void 0));
}
